import { createAction, props } from "@ngrx/store";
import {
  RoomRecordingDeleteCmd,
  RoomRecordingSetCmd
} from "@youm-front/room/domain";

export const roomRecordingDelete = createAction(
  "[Room] Room Recording Delete",
  props<{
    roomRecordingDeleteCmd: RoomRecordingDeleteCmd;
  }>()
);
export const roomRecordingDeleteSuccess = createAction(
  "[Room] Room Recording Delete Success",
  props<{
    roomRecordingDeleteCmd: RoomRecordingDeleteCmd;
  }>()
);
export const roomRecordingDeleteFailure = createAction(
  "[Room] Room Recording Delete Failure",
  props<{
    roomRecordingDeleteCmd: RoomRecordingDeleteCmd;
  }>()
);

export const roomRecordingSet = createAction(
  "[Room] Room Recording Set",
  props<{
    roomRecordingSetCmd: RoomRecordingSetCmd;
  }>()
);
export const roomRecordingSetSuccess = createAction(
  "[Room] Room Recording Set Success",
  props<{
    roomRecordingSetCmd: RoomRecordingSetCmd;
  }>()
);

export const roomRecordingSetFailure = createAction(
  "[Room] Room Recording Set Failure",
  props<{
    roomRecordingSetCmd: RoomRecordingSetCmd;
  }>()
);
